import { render, staticRenderFns } from "./RootProjects.vue?vue&type=template&id=575d18ca&scoped=true&"
import script from "./RootProjects.vue?vue&type=script&lang=ts&"
export * from "./RootProjects.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "575d18ca",
  null
  
)

export default component.exports